import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {combineReducers} from 'redux'
import {getFilterFromAction} from 'helpers/reducer'

export const contactsContextsInvoicesTabPivotTableKey = 'contactsContext.selected.invoicesTab.pivotTable'

export const showPosted = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_INVOICES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showPosted')
    default:
      return state
  }
}

export default combineReducers({
  showPosted,
  pivotTable: createPivotTableReducer({key: contactsContextsInvoicesTabPivotTableKey, defaultSortColumn: 'invoiceDate', defaultSortDirection: 'desc'}),
})
